package com.example.mystybag.common.ui.views

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.ColorFilter
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.core.helpers.appLogoImage
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p14
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p24
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.ui.theme.LocalTheme.p6
import com.example.mystybag.core.ui.theme.LocalTheme.p64
import com.example.mystybag.core.ui.theme.LocalTheme.p84
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.noRippleClickable

@Composable
fun ScreenCastView(modifier: Modifier) {

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier            = modifier
            .background(AppTheme.current.colors.surface)
            .statusBarsPadding()
            .navigationBarsPadding()
            .padding(start = p16, end = p16, top = p14, bottom = p24)
            .noRippleClickable {}
    ) {
        Image(
            painter     = painterResource(appLogoImage()),
            modifier    = Modifier.align(Alignment.Start)
        )

        Box(
            modifier = Modifier
                .align(Alignment.CenterHorizontally)
                .padding(top = p84, bottom = p32)
        ) {
            Image(
                painter     = painterResource(SRC.images.cast_icon),
                colorFilter = ColorFilter.tint(AppTheme.current.colors.onBackground),
                modifier    = Modifier
                    .width(p64)
                    .align(Alignment.BottomStart)
            )

            Image(
                painter     = painterResource(SRC.images.ic_cross_filled),
                colorFilter = ColorFilter.tint(AppTheme.current.colors.error),
                modifier    = Modifier
                    .size(p32)
                    .align(Alignment.TopEnd)
                    .offset(x = p6, y = -p16)
                    .clip(CircleShape)
                    .background(AppTheme.current.colors.surface)
            )
        }

        Spacer(Modifier.weight(1f))
    }
}